export enum RccapRootCause {    
    UnacceptableXm = 0,
    DonorNotReady = 1,
    RecipientNotReady = 2,
    LateStageDonorDecline = 3,
    PreselectReversal = 4,
    Packaging = 5,
    Other = 6
}